import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class ShareCalendarRequestService {
  private message = new BehaviorSubject(null);

  public sharedMessage = this.message.asObservable();

  constructor() {}

  nextMessage(calendarRequest: any) {
    this.message.next(calendarRequest);
  }
}
